import React, { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Typography } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { IconLibrary } from '@product-framework/index';
import { useServiceProvider } from '../../../../providers/ServiceProviderProvider';

function AssignToSPQuestion({
  children,
  onClose,
  isAssign = false,
  isReAssign = false,
}) {
  const { serviceProvider } = useServiceProvider();
  const { formatMessage } = useLocalization();
  const [renderChildren, setRenderChildren] = useState(false);

  const buttons = [
    {
      label: formatMessage({ id: 'YES', defaultMessage: 'Yes' }),
      onClick: () => setRenderChildren(true),
      variant: 'contained',
      color: 'primary',
      startIcon: <IconLibrary.Yes />,
    },
    {
      label: formatMessage({ id: 'NO', defaultMessage: 'No' }),
      variant: 'outlined',
      color: 'primary',
      onClick: () => onClose(),
      startIcon: <IconLibrary.No />,
    },
  ];

  if (renderChildren) {
    return children;
  }

  return (
    <Box>
      <DialogContent>
        <Typography>
          {isAssign && (
            <FormattedMessage
              id="CONFIRM_ASSIGN_JOB_TO_SP_MESSAGE"
              defaultMessage="Please confirm you that would like to assign this job to {serviceProviderName}."
              values={{
                serviceProviderName: serviceProvider?.name,
              }}
            />
          )}
          {isReAssign && (
            <FormattedMessage
              id="CONFIRM_REASSIGN_JOB_TO_SP_MESSAGE"
              defaultMessage="Please confirm that you would like to reassign this job to {serviceProviderName}."
              values={{
                serviceProviderName: serviceProvider?.name,
              }}
            />
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', my: 2 }}>
        {buttons.map(({ label, ...btn }) => (
          <Button key={label} {...btn}>
            {label}
          </Button>
        ))}
      </DialogActions>
    </Box>
  );
}

export default AssignToSPQuestion;
